import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { ReactNode } from 'react';

type FormCollapsePanelProps = {
  title: string;
  summary?: string;
  expanded: boolean;
  onToggle: () => void;
  children: ReactNode;
};

export function FormCollapsePanel({
  title,
  summary,
  expanded,
  onToggle,
  children,
}: FormCollapsePanelProps) {
  return (
    <div className="overflow-hidden rounded-md border border-[var(--erp-border)]">
      <button
        type="button"
        className={`flex w-full items-start gap-2 px-3 py-2.5 text-left transition-colors ${
          expanded
            ? 'bg-primary-50 hover:bg-primary-50'
            : 'bg-white hover:bg-secondary-50'
        }`}
        onClick={onToggle}
        aria-expanded={expanded}
      >
        {expanded ? (
          <ChevronDownIcon className="mt-0.5 h-4 w-4 shrink-0 text-secondary-500" />
        ) : (
          <ChevronRightIcon className="mt-0.5 h-4 w-4 shrink-0 text-secondary-500" />
        )}
        <span className="min-w-0 flex-1">
          <span className="block text-sm font-semibold text-secondary-900">{title}</span>
          {summary ? (
            <span className="mt-0.5 block text-xs text-secondary-500">{summary}</span>
          ) : null}
        </span>
      </button>
      {expanded ? <div className="space-y-3 border-t border-[var(--erp-border)] px-3 py-3">{children}</div> : null}
    </div>
  );
}
